import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Common_Images_Transport from '../../../common/common_imges_transport/Common_Images_Transport'

const Horoscope = () => {
    useEffect(() => {
            window.scrollTo(0, 0);
        }, []);
    return (
        <>
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white pt-4">
                    <div
                        className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden m-auto w-[120px] h-[100px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.Aries} alt="Product" />
                            </Link>
                        </div>
                    </div>
                    <div
                        className="gi-pro-content h-full p-[20px] pt-[0px] relative z-[10] flex flex-col text-center">

                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle font-normal text-[#9F2225] text-[16px] font-semibold leading-[1.2] capitalize">
                                Aries</h5>
                        </Link>
                    </div>
                </div>
            </div>

            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white pt-4">
                    <div
                        className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden m-auto w-[120px] h-[100px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                   src={Common_Images_Transport?.Taurus} alt="Product" />
                            </Link>
                        </div>
                    </div>
                    <div
                        className="gi-pro-content h-full p-[20px] pt-[0px] relative z-[10] flex flex-col text-center">

                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle font-normal text-[#9F2225] text-[16px] font-semibold leading-[1.2] capitalize">
                                Taurus</h5>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white pt-4">
                    <div
                        className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden m-auto w-[120px] h-[100px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.Gemini} alt="Product" />
                            </Link>
                        </div>
                    </div>
                    <div
                        className="gi-pro-content h-full p-[20px] pt-[0px] relative z-[10] flex flex-col text-center">

                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle font-normal text-[#9F2225] text-[16px] font-semibold leading-[1.2] capitalize">
                                Gemini</h5>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white pt-4">
                    <div
                        className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden m-auto w-[120px] h-[100px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                   src={Common_Images_Transport?.Cancer} alt="Product" />
                            </Link>
                        </div>
                    </div>
                    <div
                        className="gi-pro-content h-full p-[20px] pt-[0px] relative z-[10] flex flex-col text-center">

                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle font-normal text-[#9F2225] text-[16px] font-semibold leading-[1.2] capitalize">
                                Cancer</h5>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white pt-4">
                    <div
                        className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden m-auto w-[120px] h-[100px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.leo} alt="Product" />
                            </Link>
                        </div>
                    </div>
                    <div
                        className="gi-pro-content h-full p-[20px] pt-[0px] relative z-[10] flex flex-col text-center">

                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle font-normal text-[#9F2225] text-[16px] font-semibold leading-[1.2] capitalize">
                                Leo</h5>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white pt-4">
                    <div
                        className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden m-auto w-[120px] h-[100px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.Virgo} alt="Product" />
                            </Link>

                        </div>
                    </div>
                    <div
                        className="gi-pro-content h-full p-[20px] pt-[0px] relative z-[10] flex flex-col text-center">

                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle font-normal text-[#9F2225] text-[16px] font-semibold leading-[1.2] capitalize">
                                Virgo</h5>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white pt-4">
                    <div
                        className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden m-auto w-[120px] h-[100px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                   src={Common_Images_Transport?.Libra} alt="Product" />
                            </Link>

                        </div>
                    </div>
                    <div
                        className="gi-pro-content h-full p-[20px] pt-[0px] relative z-[10] flex flex-col text-center">

                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle font-normal text-[#9F2225] text-[16px] font-semibold leading-[1.2] capitalize">
                                Libra</h5>
                        </Link>

                    </div>
                </div>
            </div>
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white pt-4">
                    <div
                        className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden m-auto w-[120px] h-[100px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                   src={Common_Images_Transport?.Scorpio} alt="Product" />
                            </Link>
                        </div>
                    </div>
                    <div
                        className="gi-pro-content h-full p-[20px] pt-[0px] relative z-[10] flex flex-col text-center">

                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle font-normal text-[#9F2225] text-[16px] font-semibold leading-[1.2] capitalize">
                                Scorpio</h5>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white pt-4">
                    <div
                        className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden m-auto w-[120px] h-[100px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.Sagitarius} alt="Product" />
                            </Link>
                        </div>
                    </div>
                    <div
                        className="gi-pro-content h-full p-[20px] pt-[0px] relative z-[10] flex flex-col text-center">

                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle font-normal text-[#9F2225] text-[16px] font-semibold leading-[1.2] capitalize">
                                Sagitarius</h5>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="gi-product-contentmy-5">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white  shadow-xl pt-4">
                    <div
                        className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden m-auto w-[120px] h-[100px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.Capricorn} alt="Product" />
                            </Link>
                        </div>
                    </div>
                    <div
                        className="gi-pro-content h-full p-[20px] pt-[0px] relative z-[10] flex flex-col text-center">

                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle font-normal text-[#9F2225] text-[16px] font-semibold leading-[1.2] capitalize">
                                Capricorn</h5>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white pt-4">
                    <div
                        className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden m-auto w-[120px] h-[100px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.Aquarius} alt="Product" />
                            </Link>


                        </div>
                    </div>
                    <div
                        className="gi-pro-content h-full p-[20px] pt-[0px] relative z-[10] flex flex-col text-center">

                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle font-normal text-[#9F2225] text-[16px] font-semibold leading-[1.2] capitalize">
                                Aquarius</h5>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white pt-4">
                    <div
                        className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden m-auto w-[120px] h-[100px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.Piscis} alt="Product" />
                            </Link>


                        </div>
                    </div>
                    <div
                        className="gi-pro-content h-full p-[20px] pt-[0px] relative z-[10] flex flex-col text-center">

                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle font-normal text-[#9F2225] text-[16px] font-semibold leading-[1.2] capitalize">
                                Piscis</h5>
                        </Link>



                    </div>
                </div>
            </div>
        </>
    )
}

export default Horoscope